import type { Comic } from './comics';

export const categories = [
  { slug: 'all', name: '全部' },
  { slug: 'rexue', name: '热血' },
  { slug: 'lianai', name: '恋爱' },
  { slug: 'xuanyi', name: '悬疑' },
  { slug: 'qihuan', name: '奇幻' },
  { slug: 'gaoxiao', name: '搞笑' },
  { slug: 'kehuan', name: '科幻' },
  { slug: 'wuxia', name: '武侠' },
  { slug: 'dushi', name: '都市' },
  { slug: 'maoxian', name: '冒险' },
];

export interface Category {
  slug: string;
  name: string;
}